import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'

import Alert from 'components/Alert'
import Button from 'components/Button'
import FieldWithInput from 'components/FieldWithInput'
import FormFooter from 'components/FormFooter'
import Input from 'components/Input'
import paths from 'constants/paths'
import { auth } from 'data'
import assertions from 'utils/assertions'

const INITIAL_STATE = {
  email: '',
  emailValid: false,
  error: null,
  password: '',
  passwordValid: false,
  submitting: false,
}

export class SignInForm extends React.Component {
  static propTypes = {
    onCompleteRedirectTo: PropTypes.string,
  }

  state = { ...INITIAL_STATE }

  clearError = () => {
    this.setState({ error: null })
  }

  clearForm = () => {
    this.setState({ ...INITIAL_STATE })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    const { email, password } = this.state

    this.clearError()

    auth.signIn(email, password)
      .then(() => {
        console.log('signed in')

        const { history, onCompleteRedirectTo } = this.props

        this.clearForm()

        if (onCompleteRedirectTo) {
          history.push(onCompleteRedirectTo)
        } else {
          history.push(paths.REPORTS)
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error })
      })
  }

  render() {
    const {
      emailValid, error, passwordValid, submitting,
    } = this.state

    return (
      <form className="SignInForm" onSubmit={this.handleSubmit}>
        <FieldWithInput
          input={Input}
          inputProps={{
            type: 'email',
            autoComplete: 'username email',
            name: 'email',
            icon: 'user',
            onFocus: this.clearError,
          }}
          label="Email"
          labelAsPlaceholder
          validate={(e) => assertions.email(e.target.value)}
          onInvalidChange={() => this.setState({ emailValid: false })}
          onValidChange={(e) =>
            this.setState({
              email: e.target.value,
              emailValid: true,
            })
          }
        />
        <FieldWithInput
          input={Input}
          inputProps={{
            type: 'password',
            autoComplete: 'current-password',
            name: 'password',
            icon: 'lock',
            onFocus: this.clearError,
          }}
          label="Password"
          labelAsPlaceholder
          validate={(e) => assertions.notEmpty(e.target.value)}
          onInvalidChange={() => this.setState({ passwordValid: false })}
          onValidChange={(e) =>
            this.setState({
              password: e.target.value,
              passwordValid: true,
            })
          }
        />
        <FormFooter>
          <Button
            type="submit"
            disabled={!emailValid || !passwordValid || submitting}
            full
            onClick={this.handleSubmit}>
            Sign in
          </Button>
        </FormFooter>
        {error &&
          <Alert>
            {error.message}
          </Alert>
        }
      </form>
    )
  }
}

export default withRouter(SignInForm)



// WEBPACK FOOTER //
// ./src/components/SignInForm/SignInForm.js